<router-outlet></router-outlet>
<div class="appinformation">
	<app-app-information></app-app-information>
</div>
